import React from 'react';
import { AuthContext } from '../../authContext';
import './ErrorBoundary.css';

// Captura erros de renderização dos componentes filhos e evita que a tela fique em branco
class ErrorBoundary extends React.Component {

    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary capturou um erro:', error, errorInfo);
        this.reportToBackend(error, errorInfo);
    }

    reportToBackend(error, errorInfo) {
        const apiUrl = process.env.REACT_APP_API_URL;
        if (!apiUrl) return;

        const { errorContext = {} } = this.props;
        const accessToken = this.context?.accessToken;
        const looksLikeJwt = typeof accessToken === 'string' && /^[\w-]+\.[\w-]+\.[\w-]+$/.test(accessToken);

        const headers = { 'Content-Type': 'application/json' };
        if (looksLikeJwt) {
            headers['Authorization'] = `Bearer ${accessToken}`;
        }

        console.log('erro capturado pelo ErrorBoundary:', error);
        
        fetch(`${apiUrl}/post_frontend_error`, {
            method: 'POST',
            headers,
            body: JSON.stringify({
                exception: error?.message,
                stack: error?.stack,
                name: error?.name,
                componentStack: errorInfo?.componentStack,
                session_id: errorContext.sessionId,
                assistant_id: errorContext.assistantId,
                email: errorContext.email,
                type: 'frontend_error',
            })
        }).catch(reportError => {
            // Não deixamos uma falha no envio do relatório gerar outro erro.
            console.error('Falha ao reportar erro ao backend:', reportError);
        });
    }

    componentDidUpdate(prevProps) {
        const { resetKeys = [] } = this.props;
        const { resetKeys: prevResetKeys = [] } = prevProps;

        if (
            this.state.hasError &&
            resetKeys.length === prevResetKeys.length &&
            resetKeys.some((key, index) => key !== prevResetKeys[index])
        ) {
            this.reset();
        }
    }

    reset = () => {
        this.setState({ hasError: false, error: null });
    };

    render() {
        if (this.state.hasError) {
            const { title, message, fallback } = this.props;

            if (fallback) {
                return fallback;
            }

            return (
                <div className="ErrorBoundary-container">
                    <p className="ErrorBoundary-title">
                        {'An unexpected error occurred on this screen.'}
                    </p>
                    <p className="ErrorBoundary-message">
                        {'Something went wrong while loading this screen. Some browser extensions, such as automatic translators, can cause this issue. Try disabling them and reloading the page.'}
                    </p>
                    <button className="ErrorBoundary-button" onClick={this.reset}>
                        {'Try again'}
                    </button>
                    {this.state.error && (
                        <details className="ErrorBoundary-details">
                            <summary>Technical Details</summary>
                            <pre className="ErrorBoundary-stack">
                                {this.state.error.stack || this.state.error.message}
                            </pre>
                        </details>
                    )}
                </div>
            );
        }

        return this.props.children;
    }
}

ErrorBoundary.contextType = AuthContext;

export default ErrorBoundary;
